import Image from "next/image";
import type { ReactNode } from "react";

interface ImageTextProps {
  children?: ReactNode;
  imagePosition?: "left" | "right";
  imageSrc?: string;
  imageAlt?: string;
  imageSlot?: ReactNode;
  title?: string;
  text?: string;
  imageClassName?: string; // Neu: Erlaubt individuelles Styling von außen
}

export default function ImageText({
  children,
  imagePosition = "right",
  imageSrc,
  imageAlt,
  imageSlot,
  title,
  text,
  imageClassName = "", // Standardmäßig leer
}: ImageTextProps) {
  const imageElement =
    imageSlot ??
    (imageSrc && (
      <Image
        src={imageSrc}
        alt={imageAlt || "Image"}
        fill
        // GEÄNDERT: object-contain sorgt dafür, dass das Bild nicht mehr beschnitten wird
        className={`object-contain rounded-2xl ${imageClassName}`}
        sizes="(max-width: 768px) 100vw, 50vw"
      />
    ));

  const ImageContainer = (
    <div className="relative w-full h-75 md:h-112.5 lg:h-125">
      {imageElement}
    </div>
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
      {imagePosition === "left" && imageElement && ImageContainer}

      <div className="flex flex-col gap-4 justify-center py-6 md:py-10 px-4 md:px-8">
        {title && (
          <h2 className="text-3xl md:text-4xl font-semibold text-[#050a18]">
            {title}
          </h2>
        )}
        {text}
        <div className="text-slate-700 leading-relaxed">{children}</div>
      </div>

      {imagePosition === "right" && imageElement && ImageContainer}
    </div>
  );
}
